function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#AEFF00;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{fill:#16161A;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M56,34.9L30.6,49.8C30.4,49.9,30.2,50,30,50c-0.2,0-0.4-0.1-0.6-0.2L4,34.9l-4,2.3l4.5,2.6l25.5,15l25.5-15 l4.5-2.6L56,34.9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M60,30l-10.9-6.4c-0.1,0.4-0.3,0.8-0.4,1.2c-0.1,0.1-0.1,0.3-0.2,0.4c-0.2,0.4-0.3,0.7-0.5,1.1 c-0.1,0.1-0.1,0.3-0.2,0.4c-0.2,0.4-0.4,0.8-0.6,1.1c0,0.1-0.1,0.2-0.2,0.3c-1.5,2.5-3.6,4.7-6,6.3c-2.6,1.7-5.6,2.8-8.7,3.2 c-3.4,0.4-7-0.1-10.1-1.5c-2.7-1.2-5.2-3-7.2-5.2c-0.8-0.9-1.5-1.8-2.1-2.8c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2-0.4-0.4-0.7-0.6-1.1 c-0.1-0.1-0.1-0.3-0.2-0.4c-0.2-0.4-0.3-0.7-0.5-1.1c-0.1-0.1-0.1-0.3-0.2-0.4c-0.1-0.4-0.3-0.8-0.4-1.2L0,30l30,17.6L60,30z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M12.7,21.7c0.4,1.9,1.2,3.8,2.2,5.4c0,0,0,0,0,0.1c0.3,0.4,0.5,0.8,0.8,1.2c2,2.5,4.4,4.4,7.3,5.7 c3.1,1.3,6.5,1.7,9.9,1.1c3.2-0.5,6.3-2,8.7-4.2c0.9-0.8,1.7-1.7,2.5-2.7c0.3-0.4,0.6-0.8,0.8-1.2c0,0,0-0.1,0-0.1 c1-1.6,1.8-3.5,2.2-5.4c0.3-1.3,0.5-2.6,0.5-4C47.8,8,39.8,0,30,0c-9.8,0-17.8,8-17.8,17.8C12.2,19.1,12.4,20.5,12.7,21.7z  M43.3,17.8c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1c0,8.6-7,15.5-15.5,15.5c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1 C37.3,31.1,43.3,25.1,43.3,17.8z M32.2,6.7c0.6,0,1.1,0.5,1.1,1.1v2.4c3.7-9.2-11.5-2.1-11.5,0c0,1.3-0.1,19.2-1,20 c0.9,0.8,11.8-2.7,11.8-1.3c1.8,0,2.6-4,0.7-3.5v2.4c0,0.6-11.1,0.2-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1v-2.2h-2.2v2.2 c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1v-2.2h-1.1h-2.2c-0.6,0-1.1-0.5-1.1-1.1s0.5-1.1,1.1-1.1h1.1v-5.6v-5.6h-1.1 c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1h2.2h1.1V7.8c0-0.6,0.5-1.1,1.1-1.1s1.1,0.5,1.1,1.1V10h2.2V7.8 C31.1,7.2,31.6,6.7,32.2,6.7z M30,2.2c0.6,0,1.1,0.5,1.1,1.1S30.6,4.4,30,4.4c-7.3,0-13.3,6-13.3,13.3c0,0.6-0.5,1.1-1.1,1.1 c-0.6,0-1.1-0.5-1.1-1.1C14.5,9.2,21.4,2.2,30,2.2z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M60,44.4l-3.9-2.3L30.6,57c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.4-0.1-0.6-0.2L4,42.1L0,44.4L30,62L60,44.4z"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  x: 22,
  y: 7.5,
  width: 16,
  height: 21
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  className: "st1"
}, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M36.1,13.2c-0.1-0.8-0.3-1.6-0.6-2.2c-1.1-2-2.6-3.1-4.7-3.4c-1.2-0.2-2.3,0-3.4,0.5 c-1.6,0.8-2.8,2.2-3.3,4.1c-0.1,0.3-0.1,0.7-0.2,1.1c0,0-0.1,0-0.1,0c-0.3-0.1-0.7-0.1-1.1-0.1c-0.4,0.1-0.8,0.5-0.7,0.9 c0,0.2,0.1,0.5,0.2,0.7c0.1,0.2,0.2,0.3,0.3,0.5c0.4,0.6,0.7,1.1,1.1,1.7c0.1,0.2,0.3,0.5,0.3,0.7c0,0.5,0,1,0,1.5 c-0.1,0.7,0,1.3,0,2c0.1,0.8,0.4,1.4,0.7,2.1c0,0,0,0,0,0.1c0.1,0.1,0.1,0.1,0.2,0c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.3-0.2,0.4,0 c0.1,0.1,0.2,0.3,0.2,0.4c0.1,0.3,0.2,0.5,0.3,0.8c0.1,0.2,0.2,0.4,0.2,0.6c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.2,0.4-0.1,0.5,0.1 c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.4,0.3,0.8,0.5,1.2c0.1,0.3,0.3,0.5,0.4,0.7l0,0c0-0.1,0-0.1,0-0.2c0.1-0.2,0.1-0.4,0.2-0.6 c0.2-0.5,0.6-0.5,1-0.2c0.2,0.2,0.3,0.4,0.4,0.6c0.2,0.5,0.3,1.1,0.4,1.7c0,0.1,0,0.2,0,0.2l0,0c0-0.1,0.1-0.1,0.1-0.2 c0.2-0.5,0.4-0.9,0.7-1.4c0.1-0.3,0.3-0.3,0.6-0.3c0.1,0,0.1,0.1,0.2,0.1c0.1-0.5,0.4-0.9,0.7-1.2c0.2-0.3,0.5-0.2,0.6,0.1 c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.1,0.1,0.2c0.1-0.2,0.2-0.4,0.2-0.7c0.1-0.3,0.2-0.6,0.2-0.8c0.1-0.5,0.2-1,0.5-1.4 c0.1-0.2,0.4-0.2,0.5,0c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.1,0.3,0.2,0.4c0,0,0-0.1,0.1-0.1c0.6-0.9,0.9-1.9,0.9-3 c0-0.9,0-1.7,0-2.6c0-0.5,0.1-0.9,0.4-1.3c0.4-0.6,0.8-1.2,1.2-1.8c0.1-0.2,0.2-0.5,0.3-0.8c0.1-0.5,0-0.8-0.5-1 c-0.2-0.1-0.3-0.1-0.5-0.1C36.7,13.1,36.4,13.2,36.1,13.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M32.5,14.1c0.8,0,1.3-0.6,1.1-1.4c-0.1-0.3-0.2-0.4-0.4-0.3c-0.4,0.1-0.7,0.3-1,0.5C32.1,12.9,32,13,32,13 c-0.2,0.2-0.2,0.5-0.1,0.8c0.1,0.2,0.3,0.3,0.5,0.3C32.4,14.1,32.5,14.1,32.5,14.1z M27.4,14.1c0.1,0,0.2,0,0.3,0 c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0-0.8-0.3-0.9c-0.3-0.2-0.7-0.3-1-0.4c-0.2-0.1-0.4,0-0.4,0.3C26.1,13.5,26.6,14.1,27.4,14.1 L27.4,14.1z"
}));

function SvgGhostrewardStakinglogoGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 62",
    style: {
      enableBackground: "new 0 0 60 62"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, /*#__PURE__*/React.createElement("g", null, _ref7, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref8));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhostrewardStakinglogoGreen);
export default __webpack_public_path__ + "static/media/ghostrewardStakinglogo-green.abbf36adb69e8de0433be8f36dce1c5e.svg";
export { ForwardRef as ReactComponent };